import { PROMOTION_TYPE, RnbCalculatorPayload } from 'typings'
import { mapPromotionBase } from '..'
import { CampaignPromotion } from '../../../../typings/campaign'
import { mapBenefit, mapRegularRestrictions, mapScope } from './regular'

export function mapCampaignEffect(data: RnbCalculatorPayload) {
  return {
    scope: mapScope(data),
    benefit: mapBenefit(data),
    audiences: data.campaigns.length ? data.campaigns : undefined,
  }
}

export function mapCampaign(data: RnbCalculatorPayload): CampaignPromotion {
  const effect = mapCampaignEffect(data)

  return {
    ...mapPromotionBase(data),
    type: PROMOTION_TYPE.CAMPAIGN,
    campaign: effect,
    restrictions: mapRegularRestrictions(data, effect.benefit),
  }
}
